import { BotFormData, UserFormData } from "./SettingsPage.types";

export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
export const BOT_TOKEN_RE = /^\d{8,12}:[\w-]{30,}$/;

export const userErrorKeys: Record<string, keyof UserFormData> = {
  organization_name: "organization",
  first_name: "firstName",
  last_name: "lastName",
  email: "email",
  verification_code: "verificationCode",
};

export const botErrorKeys: Record<string, keyof BotFormData> = {
  bot_token: "botToken",
  tech_support_tg_name: "techSupportTGname",
};

export const normalizeErrors = (
  data: Record<string, unknown>,
  keyMap: Record<string, string>,
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(data).map(([key, value]) => [keyMap[key] || key, String(value)]),
  );

export const sameUserProfile = (left: UserFormData, right: UserFormData) =>
  left.organization === right.organization &&
  left.firstName === right.firstName &&
  left.lastName === right.lastName &&
  left.email === right.email;

export const sameBot = (left: BotFormData, right: BotFormData) =>
  left.botToken === right.botToken && left.techSupportTGname === right.techSupportTGname;

export const sanitizeTechSupportName = (value: string) => value.replace(/@/g, "");
export const sanitizeVerificationCode = (value: string) => value.replace(/\D/g, "").slice(0, 6);
